<template>
    <div class="win">
        <div class="row">
            <div class="title">
                账号：
            </div>    
            <div>
                <input type="input" class="input" v-model="account"  />
            </div>
        </div>
        <div class="row">
            <div class="title">
                密码：
            </div>    
            <div>
                <input type="password" class="input" v-model="password"  />
            </div>
        </div>
        <div class="row">
            <div class="btn" @click="click_user_access">登陆</div>
        </div>
    </div>
</template>


<script>

import {login} from '@/api/user';
import jsSHA from "jssha";
import { MessageBox, Message } from 'element-ui';
import _commonUtil from '@/js/common';
import { setToken } from '@/utils/auth';
import store from '@/store';

export default ({
  name: 'App',
  data(){
    return {
        account : '',
        password : ''
    }
  },

  
  mounted : function(){
        


  },

  methods: {

        click_user_access : function(){
            if(this.account && this.password){
                const shaObj = new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
                shaObj.update(this.password)
                const hashVal = shaObj.getHash("HEX");
                console.log(this.account,this.password,hashVal);
                login(this.account,hashVal).then(resp=>{
                    console.log(resp);
                    if(resp.code=='001'){
                        //setToken(resp.data.token);
                        store.dispatch('user/syncToken',resp.data.token).then(() => {
                            this.$router.push('/eds');
                        })
                    }
                });
            }else{
                Message({
                    message: '账号或密码信息不能为空！',
                    type: 'error',
                    duration: 5 * 1000
                })
            }
        }
  },
  
})
</script>


<style lang="less">
    .win{
        width: 50%;
        height: 400px;
        align-items: center;
        margin-top: 60px;
        .row{
            display: flex;
            width: 100%;
            height: 40px;
            margin: 10px 20px 0px 580px;
            .title{
                width: 60px;
                font-size: 16px;
                font-weight: 500;
            }
            .input{
                width: 120px;
                font-size: 14px;
            }
          .btn{
            font-size: 14px;
            margin-left: 30px;
            color:white;
            background: #7f76f5;
            border: 1px solid #000000;
            padding: 6px 40px;
          }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/user/login.vue